
import React, { useEffect, useState, useRef, useCallback } from "react";
// import './menuiteams.css';
import Modal from 'react-modal';
import { ShoppingCart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FaInfoCircle } from "react-icons/fa";
import './Ordercart.css';
import axios from 'axios';
import { useParams } from "react-router-dom"; // If using React Router
import { Button } from "react-bootstrap";
// import Payments from "./Payments";
import Paymentdata from "./Paymentdata";
import { useLocation as useRouteLocation } from "react-router-dom";
import Sheduleorder from "./Sheduleorder";
const suggestions = [
    'kphb Manjeera Trinity 3rd gate straight line',
];
// const Ordercart = ({ orderId }) => {
const Ordercart = ({ filteredDataProp = [], data }) => {
    const [walletData, setWalletData] = useState({});
    const [cartData, setCartData] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);  // ✅ Initialize state
    const [selectedService, setSelectedService] = React.useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
    const [isThirdModalOpen, setIsThirdModalOpen] = useState(false);
    const [selectedDish, setSelectedDish] = useState(null); // Added missing state for selectedDish
    const navigate = useNavigate();
    const [orderData, setOrderData] = useState(null);
    // const [cartItems, setCartItems] = useState([]);
    const { id } = useParams(); // Get ID from URL (if using routing)
    const [inputValue, setInputValue] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);

    const [selectedOrderType, setSelectedOrderType] = useState(null);
    const [packingCharges, setPackingCharges] = useState(0);
    const [deliveryCharges, setdeliveryCharges] = useState(0);
    const [selectedRestaurant, setSelectedRestaurant] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [numberOfPeople, setNumberOfPeople] = useState('');

    const [savedDetails, setSavedDetails] = useState(null);
    const [gstTotal, setGstTotal] = useState(0);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showOnlyAddress, setShowOnlyAddress] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(""); // Store map URL
    // const [showCheckout, setShowCheckout] = useState(false);
    const [items, setItems] = useState([]);
    const [isApplieds, setIsApplieds] = useState(false);
    const [coupons, setCoupons] = useState([]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    // const discount = 30;  // Fixed discount
    const deliveryCharge = 40; // or whatever amount you want
    // 6% CGST & SGST
    // const [loading, setLoading] = useState(false);
    const [showPaymentData, setShowPaymentData] = useState(false);
    const [filteredData, setFilteredData] = useState(filteredDataProp);
    const [refresh, setRefresh] = useState(false);
    const [displayData, setDisplayData] = useState([]);
    const [availableBalance, setAvailableBalance] = useState(0);
    const [availableCompany, setAvailableCompany] = useState(0);
    const [availableSelf, setAvailableSelf] = useState(0);
    const [availableCashback, setAvailableCashback] = useState(0);


    // const [isCashChecked, setIsCashChecked] = useState(false);
    const [enteredAmount, setEnteredAmount] = useState("");
    const [gst, setGst] = useState(0);
    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [isWalletChecked, setIsWalletChecked] = useState(false);
    const [isCashChecked, setIsCashChecked] = useState(false);
    const [isOnlineChecked, setIsOnlineChecked] = useState(false);
    const vendorId = Number(localStorage.getItem("vendorId") || 42);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
    const [isPaymentOptionsVisible, setIsPaymentOptionsVisible] = useState(false);
    const [isOrderReviewModalOpen, setIsOrderReviewModalOpen] = useState(false);
    const routeLocation = useRouteLocation();    // maps to "pincode"
    const [addressDetails, setAddressDetails] = useState(null);
    const [showAddress, setShowAddress] = useState(false);
    const [addresses, setAddresses] = useState([]);
    // const [selectedAddressId, setSelectedAddressId] = useState(null); // stores selected option from dropdown
    const [confirmedAddress, setConfirmedAddress] = useState(null);   // stores after Save button
    const [addressId, setAddressId] = useState(""); // Initialize with an empty string
    const [selectedAddressId, setSelectedAddressId] = useState(""); // Initialize to empty string
    const [categoryList, setCategoryList] = useState([]);
    const [showWalletOptions, setShowWalletOptions] = useState(false);
    const [selectedWalletType, setSelectedWalletType] = useState("");
    const [subTotal, setSubTotal] = useState(0);
    const [cgst, setCgst] = useState(0);
    const [sgst, setSgst] = useState(0);
    const [platformCharge, setPlatformCharge] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);

    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [orderId, setOrderId] = useState(null); // store orderId in stat
    const [serviceCharges, setServiceCharges] = useState("");
    const [platformCharges, setplatformCharges] = useState("");
    const [userId, setUserId] = useState(() => Number(localStorage.getItem("userId")));
    const [cartItems, setCartItems] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [sentItems, setSentItems] = useState({});
    const [tableCode, setTableCode] = useState("");
    const [total, settotal] = useState(0);
    const [discountAmount, setdiscountAmount] = useState(0);

    const [notes, setNotes] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [gstData, setGstData] = useState(null);
    const paymentSectionRef = useRef(null);
    const placeOrderRef = useRef(null);
    const [orderType, setOrderType] = useState(0);
    const [serviceApplied, setServiceApplied] = useState(true); // initially applied
    const [cartId, setCartId] = useState(displayData[0]?.cartId);
    const [isScheduled, setIsScheduled] = useState(false);
    const [isOrdered, setIsOrdered] = useState(false);
    // When fetching cart data, set the cartId
    useEffect(() => {
        if (displayData.length > 0) {
            setCartId(displayData[0].cartId); // or however you determine cartId
        }
    }, [displayData]);

    const toggleServiceCharges = async (cartId) => {
        console.log("toggleServiceCharges called with cartId:", cartId);
        if (!cartId) {
            console.error("Cart ID is missing. Cannot apply service charges.");
            alert("Cart ID is missing");
            return;
        }
        const newStatus = serviceApplied ? "NOT_APPLICABLE" : "APPLICABLE";
        const token = localStorage.getItem("authToken"); // ✅ get stored token
        try {
            setLoading(true);
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
                {
                    id: 0,
                    serviceCharge: newStatus,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`, // ✅ include token in headers
                    },
                }
            );
            console.log("✅ Service charge updated:", response.data);

            // Update UI
            setServiceApplied(!serviceApplied);
        } catch (error) {
            console.error(
                "❌ Failed to update service charge:",
                error.response?.data || error.message
            );
            alert("Failed to update service charge. Try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleShowGST = async (userId) => {
        const token = localStorage.getItem("authToken"); // ✅ get stored token
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/${userId}/without-seating`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ include token in headers
                    },
                }
            );
            const data = response.data;
            console.log("Fetched GST Data (Full Array):", data);
            // ✅ Ensure it's an array
            const gstArray = Array.isArray(data)
                ? data.map((item) => ({
                    serviceChargeGst: item.serviceChargeGst ?? 0,
                    platformChargeGst: item.platformChargeGst ?? 0,
                    cgst: item.cgst ?? 0,
                    sgst: item.sgst ?? 0,
                }))
                : [];

            console.log("GST Data in Array Format:", gstArray);
            setGstData(gstArray); // ✅ Save array to state
            setShowPopup(true);   // ✅ Show popup
        } catch (err) {
            console.error("❌ Error fetching GST data:", err);
        }
    };

    useEffect(() => {
        const fetchCart = async () => {
            const userId = localStorage.getItem("userId");
            const token = localStorage.getItem("authToken"); // ✅ get stored token
            if (!userId) return;
            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/${userId}/without-seating`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`, // ✅ include token in headers
                        },
                    }
                );
                if (Array.isArray(response.data) && response.data.length > 0) {
                    const cartData = response.data[0];
                    // ✅ Save cartItems
                    const items = cartData.cartItems || [];
                    setCartItems(items);
                    // ✅ Save tableCode
                    setTableCode(cartData.tableCode || "");
                    // Build categories
                    const categories = [...new Set(items.map((item) => item.dishName))];
                    setAllCategories(["Allcarts", ...categories]);
                    // Initialize quantities using itemId, default to 1
                    const initialQuantities = {};
                    items.forEach((item) => {
                        initialQuantities[item.itemId] = item.quantity > 0 ? item.quantity : 1;
                    });
                    setQuantities(initialQuantities);
                }
                setLoading(false);
            } catch (error) {
                console.error("❌ Error fetching cart:", error);
                setLoading(false);
            }
        };
        fetchCart();
    }, []);

    useEffect(() => {
        if (activeCategory === "Allcarts") {
            setFilteredItems(cartData);
        } else {
            const filtered = cartData.filter(item => item.dishName === activeCategory);
            setFilteredItems(filtered);
        }
    }, [activeCategory, cartData]);

    // Load applied coupon from localStorage
    useEffect(() => {
        const storedCoupon = localStorage.getItem("appliedCoupon");
        if (storedCoupon) {
            const parsedCoupon = JSON.parse(storedCoupon);
            setAppliedCoupon(parsedCoupon);

            // Log the discount percentage from API
            console.log(
                "Applied Coupon Discount:",
                parsedCoupon.details?.discountPercentage || 0
            );
        }
    }, []);

    // Remove coupon function
    const handleRemoveCoupon = async () => {
        try {
            const cartId = localStorage.getItem("cartId");
            const appliedCoupon = JSON.parse(localStorage.getItem("appliedCoupon"));
            const token = localStorage.getItem("authToken");
            if (!cartId || !appliedCoupon?.id) {
                alert("❌ No cart or coupon found!");
                return;
            }
            const body = {
                id: Number(appliedCoupon.id),  // must send the coupon id
                applyCoupon: "NOT_APPLIED"     // enum for removal
            };
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            console.log("✅ Coupon removed response:", response.data)
            // Clear local state and storage
            localStorage.removeItem("appliedCoupon");
            setAppliedCoupon(null);
        } catch (error) {
            console.error("❌ Failed to remove coupon:", error.response?.data || error.message);
            alert("Failed to remove coupon. Please try again.");
        }
    };

    useEffect(() => {
        const storedId = Number(localStorage.getItem("userId"));
        if (storedId) setUserId(storedId);
    }, []);


    // ========================================= NORMAL ORDER CODE ======================================= //
    const handleCheckoutClickS = async () => {
        let userId = localStorage.getItem("userId");
        let token = localStorage.getItem("authToken"); // ✅ get stored token
        // const mappedWalletType = walletTypeMap[selectedWalletType];

        // console.log("Selected Wallet Type (Mapped):", mappedWalletType);

        if (!userId) {
            alert("User ID not found. Please log in again.");
            return;
        }

        // if (selectedPaymentMethod === "Maamaas_Wallet" && !selectedWalletType) {
        //     alert("Please select a wallet type before creating the order.");
        //     return;
        // }

        try {
            localStorage.removeItem("orderId"); // Clear previous order

            // ----------------- ONLINE PAYMENT -----------------
            if (selectedPaymentMethod === "Online_Payment") {
                const isRazorpayLoaded = await loadRazorpayScript();
                if (!isRazorpayLoaded) {
                    alert("❌ Razorpay SDK failed to load.");
                    return;
                }

                const amount = grandTotal;
                const amountInPaise = Math.round(amount);
                const username = 'rzp_test_R6hte6Puir9RAR';      // replace with this rzp_live_RU5whSMu9rPV7s
                const password = 'FjLrs51Gf8Yq5OWT22CqamGF';
                const basicAuth = btoa(`${username}:${password}`);

                // Step 1: Create Razorpay order
                const orderResponse = await fetch(
                    "https://backend.maamaas.com/food/api/payments/create-order/user",
                    {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            amount: amountInPaise,
                            currency: "INR",
                            receipt: `order_${Date.now()}`,
                            notes: {
                                customer_name: savedDetails?.name || "John Doe",
                                order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
                            },
                            partial_payment: false,
                            payment_capture: 0
                        }),
                    }
                );

                if (!orderResponse.ok) throw new Error("❌ Failed to create Razorpay order");
                const orderData = await orderResponse.json();
                console.log("🆔 Razorpay Order Created:", orderData);

                // Step 2: Open Razorpay checkout
                const options = {
                    key: "rzp_test_R6hte6Puir9RAR",
                    amount: amountInPaise,
                    currency: "INR",
                    order_id: orderData.id || orderData.orderId,
                    name: "Maamaa's House",
                    description: "Order Payment",
                    prefill: {
                        name: savedDetails?.name || "Vamshi",
                        email: savedDetails?.email || "vamshikvky500@gmail.com",
                        contact: savedDetails?.mobileNumber || "9652030425",
                    },
                    theme: { color: "#3399cc" },
                    handler: async function (response) {
                        try {
                            console.log("✅ Payment Success Response:", response);

                            // Step 3: Capture Razorpay Payment
                            const captureRes = await fetch(
                                'https://backend.maamaas.com/food/api/payments/capture',
                                {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${token}`,
                                    },
                                    body: JSON.stringify({
                                        paymentId: response.razorpay_payment_id,
                                        amount: amountInPaise,
                                        currency: "INR",
                                        orderId: orderData.id || orderData.orderId,
                                    }),
                                }
                            );

                            const rawText = await captureRes.text();
                            let captureData;
                            try { captureData = JSON.parse(rawText); }
                            catch { captureData = { raw: rawText }; }

                            if (!captureRes.ok) throw new Error("❌ Payment capture failed");

                            console.log("✅ Payment captured successfully!", captureData);

                            // Step 4: Place Order in backend with token
                            const responseOrder = await axios.post(
                                `https://backend.maamaas.com/food/api/orders/orders/create/${localStorage.getItem("cartId")}`,
                                null,
                                {
                                    params: {
                                        userId,
                                        cartId: localStorage.getItem("cartId"),
                                        paymentMethod: "Online_Payment",
                                        walletType: null,
                                        razorpayPaymentId: response.razorpay_payment_id,
                                        razorpayOrderId: response.razorpay_order_id,
                                    },
                                    headers: {
                                        Authorization: `Bearer ${token}`,
                                        "Content-Type": "application/json",
                                    },
                                }
                            );

                            // Update token if backend returns a new one
                            if (responseOrder.data?.token) {
                                localStorage.setItem("authToken", responseOrder.data.token);
                                token = responseOrder.data.token;
                                console.log("🔐 Token updated in localStorage:", token);
                            }

                            if (responseOrder.status === 200 || responseOrder.status === 201) {
                                const newOrderId = responseOrder.data.orderId;
                                if (newOrderId) {
                                    localStorage.setItem("orderId", newOrderId);
                                    setOrderId(newOrderId);
                                }
                                setShowPaymentData(true);
                            } else {
                                alert("❌ Payment captured but order creation failed!");
                            }

                        } catch (err) {
                            console.error("❌ Error after payment:", err);
                            alert("❌ Payment succeeded but order failed.");
                        }
                    },
                };

                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
                return;
            }

            // ----------------- OFFLINE / WALLET PAYMENT -----------------
            const orderResponse = await axios.post(
                `https://backend.maamaas.com/food/api/orders/orders/create/${localStorage.getItem("cartId")}`,
                null,
                {
                    params: {
                        userId,
                        cartId: localStorage.getItem("cartId"),
                        paymentMethod: selectedPaymentMethod,
                        // walletType: mappedWalletType || null,
                        razorpayPaymentId: "N/A",
                        razorpayOrderId: "N/A",
                    },
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ use token
                        Accept: "*/*",
                        "Content-Type": "application/json",
                    },
                }
            );

            // Update token if returned
            if (orderResponse.data?.token) {
                localStorage.setItem("authToken", orderResponse.data.token);
                token = orderResponse.data.token;
                console.log("🔐 Token updated in localStorage:", token);
            }

            console.log("Order API Response:", orderResponse.data);

            if (orderResponse.status === 200 || orderResponse.status === 201) {
                if (orderResponse.data?.orderId) {
                    localStorage.setItem("orderId", orderResponse.data.orderId);
                    setOrderId(orderResponse.data.orderId);
                }
                setShowPaymentData(true);
            } else {
                alert("⚠️ Failed to create order.");
            }

        } catch (error) {
            console.error("API error:", error.response?.data || error.message);
            alert("Failed to proceed to checkout.");
        }
    };
    const fetchCartDetails = async () => {
        try {
            // console.log("📡 Fetching cart details...");
            // console.log("🔑 User ID:", userId);
            const token = localStorage.getItem("authToken");
            if (!userId) return;
            const res = await axios.get(
                `https://backend.maamaas.com/food/api/cart/${userId}/without-seating`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "Application/json",
                    }
                }
            );
            // ✅ Normalize API response
            const data = Array.isArray(res.data) ? res.data[0] || {} : res.data;

            // ✅ Save cartId
            if (data.cartId) {
                localStorage.setItem("cartId", data.cartId);
                // console.log("📝 Cart ID saved:", data.cartId);
            }

            // ✅ Save orderType from API
            if (data.orderType) {
                setOrderType(data.orderType); // <-- store in state
            }
            // ✅ Extract cart items safely
            const cartItems = Array.isArray(data.cartItems) ? data.cartItems : [];
            setCartItems(cartItems);

            // ✅ Generate categories (unique dish names)
            const categories = ["Allcarts", ...new Set(cartItems.map((item) => item.dishName))];
            setAllCategories(categories);

            // 🔑 Important: do NOT always override filteredItems
            // If no filter is selected, default to Allcarts
            setFilteredItems((prev) =>
                prev.length === 0 ? cartItems : prev
            );

            // ✅ Set Price Details 
            setdiscountAmount(data.discountAmount || 0);
            settotal(data.total || 0);
            setGstTotal(data.gstTotal || 0);
            setSubTotal(data.subtotal || 0);
            setCgst((data.gstTotal || 0) / 2);
            setSgst((data.gstTotal || 0) / 2);
            setPlatformCharge(data.platformCharges || 0);
            setPackingCharges(data.packingTotal || 0);
            setServiceCharges(data.serviceCharges || 0);
            setGrandTotal(data.grandTotal || 0);
            setdeliveryCharges(data.deliveryCharges || 0);
            setplatformCharges(data.platformCharges || 0);

        } catch (err) {
            console.error("❌ Error fetching price details:", err.message);
        }
    };
    useEffect(() => {
        fetchCartDetails();
    }, [userId, refresh]); // 🔁 refresh dependency

    const paymentButtonsRef = useRef(null);
    const walletSectionRef = useRef(null);

    useEffect(() => {
        const flag = localStorage.getItem("showPaymentData") === "true";
        const service = localStorage.getItem("selectedService");
        const order = localStorage.getItem("orderData");

        if (flag && service && order) {
            setShowPaymentData(true);
            setSelectedService(service);
            setOrderData(JSON.parse(order));
        }

        // Optional: Clear after use
        localStorage.removeItem("showPaymentData");
        localStorage.removeItem("selectedService");
        localStorage.removeItem("orderData");
    }, []);
    useEffect(() => {
        const storedCoupon = JSON.parse(localStorage.getItem("couponData"));
        if (storedCoupon) {
            setAppliedCoupon(storedCoupon);
            setApplied(true);
        }
    }, []);


    React.useEffect(() => {
        const service = localStorage.getItem('selectedService');
        setSelectedService(service);
    }, []);
    // const cgst = 5;
    // const sgst = 5;
    const [billingData, setBillingData] = useState({});
    const originalDiscounts = billingData.discount || 0; // 1. define original
    const [discounts, setDiscounts] = useState(originalDiscounts); // 2. define state
    // const isApplieds = discounts !== 0; // 3. use state after it's initialized
    // Initialize originalDiscount first
    const originalDiscount = billingData.serviceCharges || 0;
    // const [packingCharge, setPackingCharge] = useState(0);
    const originalServiceCharge = billingData.serviceCharges || 0;
    const isApplied = serviceCharges !== 0;
    const discountValue = parseFloat(originalDiscount) || 0;
    useEffect(() => {
        axios.get("https://backend.maamaas.com/food/addresses/addresscategory")
            .then(response => {
                setCategoryList(response.data);
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
            });
    }, []);

    useEffect(() => {
        console.log("Addresses array:", addresses); // Log to check if the addresses are loaded correctly
    }, [addresses]);

    useEffect(() => {
        const fetchWalletData = async () => {

            const token = localStorage.getItem("authToken");
            try {
                const response = await axios.get(`https://backend.maamaas.com/subscription/api/user/wallet/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-type": "Application/json"
                    }
                });
                const data = response.data;
                console.log("✅ Wallet Data:", data);
                // Save to local storage
                localStorage.setItem("walletData", JSON.stringify(data));

                // Set to state
                setWalletData(data);
            } catch (error) {
                console.error("❌ Failed to fetch wallet data:", error);
            }
        };

        if (userId) {
            fetchWalletData();
        }
    }, [userId]);
    // handleCheckboxChange((all the category of the products and all ))
    const handleCheckboxChange = async (e, method) => {
        const isChecked = e.target.checked;
        console.log(`Checkbox for ${method} is checked: `, isChecked);
        let newSelectedMethod = "";
        if (isChecked) {
            if (method === "wallet") {
                setIsWalletChecked(true);
                setIsCashChecked(false);
                setIsOnlineChecked(false);
                newSelectedMethod = "Maamaas_Wallet";
                setShowWalletOptions(true); // ✅ show options
            } else if (method === "cash") {
                setIsWalletChecked(false);
                setIsCashChecked(true);
                setIsOnlineChecked(false);
                newSelectedMethod = "Cash";
                setShowWalletOptions(false); // ✅ hide if not wallet
            } else if (method === "online") {
                setIsWalletChecked(false);
                setIsCashChecked(false);
                setIsOnlineChecked(true);
                newSelectedMethod = "Online_Payment";
                setShowWalletOptions(false); // ✅ hide if not wallet
            }
        } else {
            // Unchecking
            if (method === "wallet") {
                setIsWalletChecked(false);
                setShowWalletOptions(false); // ✅ hide when unchecked
            }
            if (method === "cash") setIsCashChecked(false);
            if (method === "online") setIsOnlineChecked(false);
            newSelectedMethod = "";
        }

        setSelectedPaymentMethod(newSelectedMethod);
        console.log("✅ Will set selectedPaymentMethod to:", newSelectedMethod);
    };
    //-----------------------------------------------------------------------------------------------------------
    const [applied, setApplied] = useState(() => {
        return localStorage.getItem("appliedCoupon") ? true : false;
    });
    // const coupon = location.state?.coupon; // Retrieve coupon data
    const coupon = routeLocation.state?.coupon || JSON.parse(localStorage.getItem("couponData")) || null;
    useEffect(() => {
        fetch("https://backend.maamaas.com/food/api/coupon/coupon/1") // Replace with your GET API URL
            .then((response) => response.json())
            .then((data) => setCoupons(data))
            .catch((error) => console.error("Error fetching coupons:", error));
    }, []);

    // Fetch Coupon by ID
    // console.log("Location State:", location.state); // 🔍 Debugging
    // const navigate = useNavigate();
    useEffect(() => {
        const userId = Number(localStorage.getItem("userId"));
        const token = localStorage.getItem("authToken"); // ✅ get token

        if (!userId) {
            console.error("❌ User ID not found. User might not be logged in.");
            return;
        }

        // Fetching available balance with token
        axios
            .get(`https://backend.maamaas.com/subscription/api/user/wallet/${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`, // 🔐 send token
                    Accept: "*/*",
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                console.log("✅ Full Balance Response:", response.data);
                const data = response.data;

                setAvailableBalance(data.balance || 0);
                setAvailableCompany(data.companyCreditedAmount || 0);
                setAvailableSelf(data.selfCreditedAmount || 0);
                setAvailableCashback(data.cashbacks || 0);

                // ✅ Update token if backend returns a new one
                if (data?.token) {
                    localStorage.setItem("authToken", data.token);
                    console.log("🔐 Token updated in localStorage:", data.token);
                }
            })
            .catch((error) => {
                console.error("❌ Balance API Error:", error);
                setAvailableBalance(0);
                setAvailableCompany(0);
                setAvailableSelf(0);
                setAvailableCashback(0);
            });
    }, []);

    useEffect(() => {
        // console.log("Updated displayData:", filteredDataProp);
        setDisplayData(filteredDataProp);
    }, [filteredDataProp]);

    useEffect(() => {
        const updateData = () => {
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            if (filteredDataProp && Array.isArray(filteredDataProp) && filteredDataProp.length > 0) {
                setFilteredData(filteredDataProp);

                // Save only if not already stored (prevent quota issues)
                const currentStored = localStorage.getItem("cartItems");
                const newData = JSON.stringify(filteredDataProp);

                if (currentStored !== newData) {
                    try {
                        localStorage.setItem("cartItems", newData);
                    } catch (e) {
                        console.warn("🛑 Storage quota exceeded, not saving cartItems.");
                    }
                }
            }
        };

        updateData();

        const interval = setInterval(() => {
            setRefresh(prev => prev + 1);
            updateData();
        }, 1000); // ⬆ increased to 1000ms to avoid flooding

        return () => clearInterval(interval);
    }, [filteredDataProp, refresh]);

    useEffect(() => {
        const fetchCartData = async () => {
            const userId = localStorage.getItem("userId");
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            console.log("📦 userId:", userId);
            console.log("📦 vendorId:", vendorId);
            console.log("📦 token:", token);

            if (!userId || !vendorId) {
                console.error("🚨 userId or vendorId is missing!");
                return;
            }

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/${userId}`,
                    {
                        headers: token ? { Authorization: `Bearer ${token}` } : {},
                    }
                );

                console.log("📥 Full API Response:", response);

                const tokenFromHeader = response.headers['authorization'] || response.headers['Authorization'];
                if (tokenFromHeader) {
                    localStorage.setItem("authToken", tokenFromHeader);
                    console.log("🔐 Updated token from header");
                }
                if (response.data.token) {
                    localStorage.setItem("authToken", response.data.token);
                    console.log("🔐 Updated token from response body");
                }

                const cartItems = response.data.cartItems || [];
                console.log("🛒 Cart items:", cartItems);

                setCartData(cartItems);
                setFilteredItems(cartItems);

                const categories = [...new Set(cartItems.map(item => item.dishName))];
                setAllCategories(["Allcarts", ...categories]);

            } catch (error) {
                console.error("❌ Error fetching cart data:", error);
                if (error.response) {
                    console.error("📛 Response Error:", error.response.data);
                } else if (error.request) {
                    console.error("📛 No Response from server:", error.request);
                } else {
                    console.error("📛 General Error:", error.message);
                }
            }
        };

        fetchCartData();
    }, []);

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        closeSecondModal();

        if (value.trim() === '') {
            setShowDropdown(false);
            setFilteredSuggestions([]); // Clear suggestions if input is empty
            return;
        }

        // Filter suggestions and update the state
        const filtered = suggestions.filter((item) =>
            item.toLowerCase().includes(value.toLowerCase())
        );

        setFilteredSuggestions(filtered);
        setShowDropdown(filtered.length > 0); // Show dropdown only if filtered suggestions exist
    };

    const handleSelect = (value) => {
        setInputValue(value);
        setShowDropdown(false);

        // Generate Google Maps URL
        const encodedLocation = encodeURIComponent(value);
        const mapsUrl = `https://maps.app.goo.gl/JvgyXhfkMA3pp7LX6?q=${encodedLocation}`;

        setSelectedLocation(mapsUrl); // ✅ Store Google Maps URL in state
        setIsSecondModalOpen(true);

        console.log("📍 Google Maps URL:", mapsUrl); // Debugging
        // alert(`Google Maps Link: ${mapsUrl}`); // Show link in an alert
    };

    const handleUseMyLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
                    window.open(mapsUrl, '_blank');  // Opens Google Maps in a new tab
                },
                (error) => {
                    alert("Location access denied. Please enable location services.");
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    };

    const handleSaveDetails = () => {
        const details = {
            orderType: selectedOrderType,
            restaurant: selectedRestaurant || "Maamaas House",
            date: selectedDate,
            time: selectedTime || "",
            address: "Manjeera Trinity Mall",
        };

        setSavedDetails(details);
        setShowOnlyAddress(false); // if you’re using this elsewhere

        closeThirdModal(); // close modal after saving
        // ❌ Don’t use window.location.reload() (causes full app refresh & state loss)
    };

    useEffect(() => {
        const storedOrderData = localStorage.getItem("orderData");
        const storedShowCheckout = localStorage.getItem("showCheckout");

        if (storedOrderData && storedShowCheckout === "true") {
            setOrderData(JSON.parse(storedOrderData));
            // setShowCheckout(true);

            // ✅ Clear `showCheckout` after showing it once
            localStorage.removeItem("showCheckout");
        }
    }, []);

    cartItems.reduce((acc, item) => ({ ...acc, [item.dishId]: item.quantity || 1 }), {})
    const incrementQuantity = async (item) => {
        if (!item?.itemId) {
            console.error("❌ Invalid itemId");
            return;
        }

        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken"); // ✅ get token

        if (!userId) {
            alert("Please log in to update items.");
            return;
        }

        const currentQty = quantities[item.itemId] || 0;
        const newQuantity = currentQty + 1;

        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQuantity}&itemId=${item.itemId}`;
        console.log("📤 incrementQuantity PUT URL:", apiUrl, "quantity:", newQuantity);

        try {
            const response = await axios.put(apiUrl, null, {
                params: { quantity: newQuantity },
                headers: {
                    Authorization: `Bearer ${token}`, // 🔐 send token
                    "Content-Type": "application/json",
                    Accept: "*/*",
                },
            });

            // ✅ Update token if backend returns a new one
            if (response.data?.token) {
                localStorage.setItem("authToken", response.data.token);
                console.log("🔐 Token updated in localStorage:", response.data.token);
            }

            console.log(`✅ Item ${item.itemId} quantity updated to ${newQuantity}`);

            setQuantities((prev) => ({
                ...prev,
                [item.itemId]: newQuantity,
            }));

            setDisplayData((prev) =>
                prev.map((i) =>
                    i.itemId === item.itemId ? { ...i, quantity: newQuantity } : i
                )
            );

        } catch (err) {
            console.error(
                "❌ Error updating item quantity:",
                err.response?.data || err.message
            );
            alert("Unable to update cart right now. Please try again.");
        }
    };

    const decrementQuantity = async (item) => {
        if (!item?.itemId) {
            console.error("❌ Invalid itemId");
            return;
        }

        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken"); // ✅ get token

        if (!userId) {
            alert("Please log in to update items.");
            return;
        }

        const currentQty = quantities[item.itemId] || 0;
        if (currentQty === 0) return;

        const newQuantity = currentQty - 1;

        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQuantity}&itemId=${item.itemId}`;
        console.log("📤 decrementQuantity PUT URL:", apiUrl, "quantity:", newQuantity);

        try {
            const response = await axios.put(apiUrl, null, {
                params: { quantity: newQuantity },
                headers: {
                    Authorization: `Bearer ${token}`, // 🔐 send token
                    "Content-Type": "application/json",
                    Accept: "*/*",
                },
            });

            // ✅ Update token if backend returns a new one
            if (response.data?.token) {
                localStorage.setItem("authToken", response.data.token);
                console.log("🔐 Token updated in localStorage:", response.data.token);
            }

            console.log(`✅ Item ${item.itemId} quantity updated to ${newQuantity}`);

            if (newQuantity === 0) {
                setDisplayData((prev) => prev.filter((i) => i.itemId !== item.itemId));
                setQuantities((prev) => {
                    const q = { ...prev };
                    delete q[item.itemId];
                    return q;
                });
            } else {
                setQuantities((prev) => ({
                    ...prev,
                    [item.itemId]: newQuantity,
                }));
            }

        } catch (err) {
            console.error(
                "❌ Error updating item quantity:",
                err.response?.data || err.message
            );
            alert("Unable to update cart right now. Please try again.");
        }
    };

    useEffect(() => {
        let isMounted = true;

        const vendorId = localStorage.getItem("vendorId") || "1";
        const token = localStorage.getItem("authToken");

        fetch(`https://backend.maamaas.com/food/api/cart/${userId}/without-seating`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (isMounted) {
                    console.log("Fetched Data:", data);
                    localStorage.setItem("cartItems", JSON.stringify(data)); // Store in localStorage
                    setItems(Array.isArray(data) ? data : []);
                }
            })
            .catch((error) => console.error("Error fetching data:", error));

        return () => {
            isMounted = false;
        };
    }, []);

    const handleClearCart = async () => {
        const userId = localStorage.getItem("userId"); // get userId from localStorage
        const token = localStorage.getItem("authToken"); // ✅ get token

        if (!userId) {
            alert("User ID not found!");
            return;
        }

        // ✅ Fix: Inject userId properly into the API URL
        const apiUrl = `https://backend.maamaas.com/food/api/cart/delete/user/${userId}`;

        try {
            const response = await fetch(apiUrl, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            if (response.ok) {
                alert("Cart cleared successfully!");
                // instead of reloading page, better update state
                // but if you want reload, keep below line
                window.location.reload();
            } else {
                const errorText = await response.text();
                console.error("❌ Server Error:", errorText);
                alert("Failed to clear the cart.");
            }
        } catch (error) {
            console.error("⚠️ Error clearing cart:", error);
            alert("An error occurred while clearing the cart.");
        }
    };

    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedDish(null);
    };
    const openSecondModal = () => setIsSecondModalOpen(true);
    const closeSecondModal = () => setIsSecondModalOpen(false);
    const openThirdModal = () => setIsThirdModalOpen(true);
    const closeThirdModal = () => setIsThirdModalOpen(false);
    const [offers, setOffers] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 480);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div>

            {/* <p className="breadcrumb" style={{ marginTop: "-23px", fontSize: "22px", marginLeft: "0px", marginBottom: "-12px" }}>
                <Link to="/home" style={{ color: "#757171", textDecoration: "none" }}>Home</Link><span className="separator"> &gt; </span><Link to="/food" style={{ color: "#757171", textDecoration: "none" }}>Food</Link> <span className="separator"> &gt; </span><Link to="/maamaas" style={{ color: "#757171", textDecoration: "none" }}>Maamaas</Link><span className="separator"> &gt; </span> <span style={{ color: "#b15dc6" }}>Cart</span>
            </p> */}
            {!showPaymentData ? (

                <div className="col-lg-12 col-md-12 col-sm-12 col-12 cartsizes hide-scrollbar">
                    {/* Button Section */}

                    {/* ===================  check Out code ============================================== */}
                    <div
                        style={{
                            overflowY: isMobile ? "none" : "auto",
                            scrollbarWidth: "none",
                            marginTop: "-50px",
                            height: "550px",
                        }}
                        className="carts1 carts-scroll-datass hide-scrollbar"
                    >
                        <>
                            <div>
                                <>
                                    <style>{`
        .order-wrapper {
          display: flex;
          flex-direction: column;
        //   padding: 5px;
           background: #b15cd6;
          font-family: sans-serif;
         border-radius: 10px;
         margin-top:10px;
        }

        .order-container {
          background: #b15cd6;
          border-radius: 10px;
          color: #fff;
          padding: 15px;
          margin-bottom: 20px;
        }

        .order-heading {
          font-weight: bold;
          text-align: center;
          font-size: 22px;
          margin-bottom: 15px;
        }

        .order-table-wrapper {
          overflow-x: auto;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 15px;
          font-weight: bold;
        }

        th, td {
          padding: 10px;
         
          text-align: center;
          font-size: 18px;
        }


@media (max-width: 480px) {
  th, td {
    font-size: 8px;
  }
}
        .quantity-box {
          display: flex;
          align-items: center;
          background: #fff;
          border-radius: 10px;
          width: 80px;
          margin: auto;
        }

        .quantity-box button {
          border: none;
          background: transparent;
          padding: 5px;
          cursor: pointer;
          color: #000;
          font-weight: bold;
          font-size:16px;
        }

        .quantity-box span {
          padding: 0 10px;
          font-weight: 800;
          color: #000;
        }

        .no-data {
          text-align: center;
          padding: 20px;
          font-weight: bold;
        }

        .total-section {
          background: #b15cd6;
          border-radius: 10px;
          padding: 20px;
          color: white;
        }

        .pricedetails {
          display: flex;
        //   align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        //   flex-wrap: wrap;
        }

        .pricedetails dt,
        .pricedetails dd {
          margin: 0;
          font-size:19px;
        }

        .pricedetails dd {
          min-width: 50px;
          text-align: right;
        }

        .total-button {
          padding: 4px 10px;
          width: 85px;
          height: 35px;
          cursor: pointer;
          border: none;
          border-radius: 10px;
          color: white;
          font-weight: bold;
        }

        hr {
          border: 2px solid #000;
          margin: 15px 0;
        }

        @media (max-width: 1200px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
        }

        @media (max-width: 768px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
        }
            /* ===== Scrollbar Styling for Ordercart Component ===== */
  .ordercart-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .ordercart-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 10px;
  }

  .ordercart-wrapper::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.4);
  }

  .ordercart-wrapper::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Firefox support */
  .ordercart-wrapper {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
  }
     .hide-scrollbar {
    scrollbar-width: none;      /* Firefox */
    -ms-overflow-style: none;   /* Internet Explorer / Edge */
  }
  .hide-scrollbar::-webkit-scrollbar {
    display: none;              /* Chrome, Safari, Opera */
  }
      `}</style>
                                    <div className="order-wrapper">
                                        {/* Order Items Table */}
                                        <div className="order-container">
                                            <div style={{ position: "relative", textAlign: "center", marginBottom: "16px" }}>
                                                <h4 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>Review your Cart</h4>
                                                <button
                                                    onClick={handleClearCart}
                                                    style={{
                                                        position: "absolute",
                                                        right: "0",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        color: "red",
                                                        background: "#fff",
                                                        border: "none",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                        fontSize: "18px"
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                            <div className="order-table-wrapper">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>S.NO</th>
                                                            <th>ITEM</th>
                                                            <th>QUANTITY</th>
                                                            <th>PRICE</th>
                                                            <th>TOTAL</th>
                                                            {/* <th>NOTE</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {displayData.length > 0 ? (
                                                            displayData.map((item, index) => (
                                                                <tr key={item.itemId} style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                    <td>{index + 1}</td>
                                                                    <td style={{ fontWeight: "bold" }}>{item.dishName}</td>
                                                                    <td>
                                                                        <div className="quantity-box">
                                                                            <button onClick={() => decrementQuantity({ ...item, itemId: item.itemId })}>-</button>
                                                                            <span>{quantities[item.itemId] || 0}</span> {/* use itemId */}
                                                                            <button onClick={() => incrementQuantity({ ...item, itemId: item.itemId })}>+</button>
                                                                        </div>
                                                                    </td>
                                                                    <td>₹{item.price?.toFixed(2)}</td>

                                                                    <td>₹{item.totalPrice.toFixed(2)}</td>
                                                                    {/* <td style={{ width: "150px" }}>
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Add note..."
                                                                            style={{
                                                                                width: "64%",
                                                                                padding: "6px 8px",
                                                                                borderRadius: "8px",
                                                                                border: "1px solid #ccc",
                                                                                outline: "none",
                                                                                fontSize: "14px",
                                                                                transition: "border-color 0.2s, box-shadow 0.2s",
                                                                            }}
                                                                            onFocus={(e) => (e.target.style.boxShadow = "0 0 5px #28a745")}
                                                                            onBlur={(e) => (e.target.style.boxShadow = "none")}
                                                                        />
                                                                    </td> */}
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="no-data">No data available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <hr />
                                        {/* Total Pricing Summary */}

                                        {/*  */}
                                        <div className="total-section">
                                            <dl>
                                                <div className="pricedetails">
                                                    <dt>Sub Total</dt>
                                                    <dd>₹{subTotal}</dd>
                                                </div>


                                                <div className="pricedetails">
                                                    <dt>Platform Charges</dt>
                                                    <dd>₹{platformCharges}</dd>
                                                </div>
                                                {orderType == "DINE_IN" && (

                                                    <div className="pricedetails">
                                                        <dt
                                                            onClick={() => {
                                                                const cartId = localStorage.getItem("cartId"); // ✅ get stored cartId
                                                                console.log("Calling toggleServiceCharges with cartId:", cartId);
                                                                toggleServiceCharges(cartId);
                                                            }}
                                                            style={{
                                                                cursor: "pointer",
                                                                padding: "4px 8px",
                                                                borderRadius: "5px",
                                                                border: "1px solid #ccc",
                                                                background: serviceApplied ? "rgb(242, 242, 242)" : "rgb(242, 242, 242)",
                                                                fontWeight: "bold",
                                                                color: "#000",
                                                                fontSize: "15px",
                                                            }}
                                                        >
                                                            Service Charges {serviceApplied ? "(Remove)" : "(Apply)"}
                                                        </dt>
                                                        <dd>₹{serviceCharges}</dd>
                                                    </div>
                                                )}

                                                {packingCharges > 0 && (
                                                    <div className="pricedetails">
                                                        <dt>Packing Charges</dt>
                                                        <dd>₹{packingCharges.toFixed(2)}</dd>

                                                    </div>
                                                )}

                                                {deliveryCharges > 0 && (
                                                    <div className="pricedetails">
                                                        <dt>Delivery Charges</dt>
                                                        <dd>₹{deliveryCharges}</dd>
                                                    </div>
                                                )}
                                                <div className="pricedetails">
                                                    <dt>GST   <FaInfoCircle
                                                        style={{ marginLeft: "8px", cursor: "pointer", color: "rgb(0 187 90)" }}
                                                        onClick={() => handleShowGST(userId)}
                                                    /></dt>
                                                    <dd>₹{gstTotal.toFixed(2)}</dd>
                                                </div>
                                                <hr />

                                                <div className="pricedetails" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    <dt> Total</dt>

                                                    <dd>₹{total}</dd>
                                                </div>
                                                {/* <div
                                                    className="pricedetails"
                                                    style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                                >
                                                    {!appliedCoupon || discountAmount <= 0 ? (
                                                        // Show Apply button if no coupon OR discount is 0
                                                        <button
                                                            style={{
                                                                padding: "4px 8px",
                                                                fontSize: "13px",
                                                                cursor: "pointer",
                                                                borderRadius: "5px",
                                                                border: "1px solid #ccc",
                                                                background: "#f2f2f2",
                                                            }}
                                                            onClick={() =>
                                                                navigate("/profilepage", { state: { activeCategory: "Notifications" } })
                                                            }
                                                        >
                                                            Apply Discount
                                                        </button>
                                                    ) : (
                                                        // Show Remove + discount only when discountAmount > 0
                                                        <div
                                                            className="pricedetails"
                                                            style={{ display: "flex", alignItems: "center", gap: "5px" }}
                                                        >
                                                            <button
                                                                style={{
                                                                    padding: "4px 8px",
                                                                    fontSize: "13px",
                                                                    cursor: "pointer",
                                                                    borderRadius: "5px",
                                                                    border: "1px solid #ccc",
                                                                    background: "#f2f2f2",
                                                                }}
                                                                onClick={handleRemoveCoupon}
                                                            >
                                                                Remove
                                                            </button>
                                                            <dd>-₹{discountAmount}</dd>
                                                        </div>
                                                    )}
                                                </div> */}

                                                {/* <div className="pricedetails">
                                                    <dt>Platform Charges</dt>
                                                    <dd>₹{platformCharge}</dd>
                                                </div> */}
                                                <hr />
                                                <div className="pricedetails" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    <dt>Grand Total</dt>
                                                    <dd>₹{grandTotal}</dd>
                                                </div>
                                            </dl>
                                        </div>
                                    </div>
                                </>
                            </div>
                            <div
                                style={{
                                    height: "auto",
                                    background: "rgb(177, 93, 198)",
                                    borderRadius: "10px",
                                    marginTop: "20px",
                                    padding: "10px",
                                    color: "#fff",
                                }}
                            >
                                <h3
                                    style={{
                                        fontWeight: "bold",
                                        display: "flex",
                                        justifyContent: "center",
                                        marginBottom: "10px",
                                    }}
                                >
                                    <Link
                                        to="/Newmenuiteam"
                                        style={{ textDecoration: "none", marginTop: "10px" }}
                                    >
                                        <p className="missed">
                                            <span style={{ color: "#000" }}>Missed Something?</span>{" "}
                                            <span>Add More Items</span>
                                        </p>
                                    </Link>
                                </h3>
                            </div>
                            <div className="row">

                                <div
                                    style={{

                                        background: 'rgb(24, 157, 62)',
                                        borderRadius: '25px',
                                        color: '#fff',

                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}>
                                    {savedDetails && (
                                        <>

                                            {confirmedAddress && selectedOrderType !== "Take Away" && selectedOrderType !== "Dine In" && (
                                                <div
                                                    style={{
                                                        background: 'rgb(177, 93, 198)',
                                                        borderRadius: '10px',
                                                        color: '#fff',
                                                        padding: '20px 30px',
                                                        margin: '10px 0',
                                                        fontFamily: 'Arial, sans-serif'
                                                    }}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: '40px',
                                                            fontSize: "16px",
                                                            justifyContent: 'space-between',
                                                            marginLeft: "100px"
                                                        }}>

                                                        <div style={{ flex: 1, minWidth: "250px", display: 'flex', flexDirection: 'column', gap: '10px' }}>

                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Location</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{addressDetails?.categoree || "N/A"}</div>
                                                            </div>

                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Address Line</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.addressLine}</div>
                                                            </div>
                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Pincode</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.pincode}</div>
                                                            </div>

                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Date</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{savedDetails?.date ? new Date(savedDetails.date).toLocaleDateString("en-GB") : "N/A"}</div>
                                                            </div>
                                                        </div>
                                                        {/* Right Column */}
                                                        <div style={{ flex: 1, minWidth: "250px", display: 'flex', flexDirection: 'column', gap: '10px', marginLeft: "50px" }}>


                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Landmark</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.landMark}</div>
                                                            </div>

                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>City</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.city}</div>
                                                            </div>

                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>State</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.state}</div>
                                                            </div>
                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Time</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{savedDetails?.time ?? "N/A"}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                            {/* Internal CSS */}
                            <style>{`
        .payment-container {
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }

        .primary-btn {
            padding: 10px 20px;
            background-color: #b15dc6;
            color: #fff;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            width: 150px;
            font-weight: bold;
            font-size: 20px;
        }

        .payment-options {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 30px;
        }

        .payment-options button {
            padding: 10px 20px;
            border: none;
            border-radius: 5px;
            width: 140px;
            font-weight: bold;
            font-size: 20px;
            cursor: pointer;
        }

        .pay-now {
            background-color: #4CAF50;
            color: #fff;
        }

        .pay-later {
            background-color: #f44336;
            color: #fff;
        }

        .method-box-container {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 20px;
            margin-top: 40px;
        }

        .method-box {
            flex: 1;
            // min-width: 250px;
            // max-width: 30%;
            
            background: rgb(177, 93, 198);
            border-radius: 10px;
            margin-bottom:0px;
            font-size:12px;
            display: flex;
            align-items: center;
            // padding: 0 20px;
            box-sizing: border-box;
        }

        .method-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .method-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-balance-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-container {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #b15cd6;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: 10px;
            margin-bottom: 20px;
            padding: 0 30px;
        }

        /* Responsive for smaller screens */
        @media (max-width: 768px) {
            .method-box {
                max-width: 100%;
            }

            .payment-options {
                flex-direction: column;
                align-items: center;
                gap: 15px;
            }
        }
    `}</style>

                            {/* Render Scheduled Order section if savedDetails exists */}



                        </>


                        <style>{`
        .payment-row {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin-top: 60px;
            flex-wrap: wrap;
        }

        .payment-box {
            flex: 1;
            min-width: 200px;
            max-width: 20%;
            height: 60px;
            background: rgb(177, 93, 198);
            border-radius: 10px;
            display: flex;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
            justify-content: center;
        }

        .payment-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .payment-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-amount-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-wrapper {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #b15cd6;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: -30px;
            margin-bottom: 20px;
            padding: 0 30px;
        }

        @media (max-width: 768px) {
            .payment-box {
                max-width: 100%;
            }
        }
           @media (min-width: 992px) and (max-width: 1050px)  {
    .col-lg-7 {
        flex: 0 0 auto;
        width: 62%;
    }
}
     .hide-scrollbar {
    scrollbar-width: none;      /* Firefox */
    -ms-overflow-style: none;   /* Internet Explorer / Edge */
  }
  .hide-scrollbar::-webkit-scrollbar {
    display: none;              /* Chrome, Safari, Opera */
  }
    
            
    `}</style>
                        <div>
                            {/* Always show payment options without Order Now button */}
                            <div style={{ marginTop: "-40px" }} ref={paymentSectionRef}>
                                {/* Payment Methods */}
                                <div className="payment-row">
                                    {/* Online Payment Checkbox */}
                                    <div className="payment-box">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => handleCheckboxChange(e, "online")}
                                        />
                                        <h3>Online Payment</h3>
                                    </div>
                                </div>

                                {/* Place Order Button */}
                                <div
                                    style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
                                    ref={placeOrderRef}
                                >
                                    <button
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            backgroundColor: "#b15cd6",
                                            color: "white",
                                            padding: "12px 30px",
                                            border: "none",
                                            borderRadius: "8px",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                            transition: "all 0.3s ease",
                                        }}
                                        onMouseOver={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#9e49c4")
                                        }
                                        onMouseOut={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#b15cd6")
                                        }
                                        onClick={handleCheckoutClickS}
                                    >
                                        Place Order
                                    </button>
                                </div>
                            </div>



                        </div>



                        {savedDetails && (
                            <div className="row">
                                <div className="col-12">

                                    {/* Place Order Button */}


                                    {/* Pay Now / Later */}
                                    {isPaymentOptionsVisible && (
                                        <div ref={walletSectionRef}>
                                            {/* ... your payment method boxes ... */}
                                        </div>
                                    )}


                                    <div
                                        style={{
                                            marginTop: "20px",
                                            padding: "15px",
                                            // border: "2px solid #b15dc6",
                                            // borderRadius: "8px",
                                            // background: "#f9f4fb",
                                            textAlign: "center",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            color: "#333",
                                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                        }}
                                    >
                                        <div style={{ marginTop: "-40px" }} ref={paymentSectionRef}>

                                            <div className="payment-row">


                                                {/* Online */}
                                                {/* <div className="payment-box">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckboxChange(e, "online")}
                                                    />
                                                    <h3>Online Payment</h3>
                                                </div> */}
                                            </div>

                                            {/* Place Order Button */}
                                            {/* <div
                                                style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
                                                ref={placeOrderRef}
                                            >
                                                <button
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        backgroundColor: "#b15cd6",
                                                        color: "white",
                                                        padding: "12px 30px",
                                                        border: "none",
                                                        borderRadius: "8px",
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                        cursor: "pointer",
                                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    onMouseOver={(e) =>
                                                        (e.currentTarget.style.backgroundColor = "#9e49c4")
                                                    }
                                                    onMouseOut={(e) =>
                                                        (e.currentTarget.style.backgroundColor = "#b15cd6")
                                                    }
                                                    onClick={handleCheckoutClickSs}
                                                >
                                                    Place Order
                                                </button>
                                            </div> */}
                                        </div>
                                    </div>

                                    {/* Checkout / Payment Data Display */}
                                    {/* {showPaymentData && orderId && (
                                        <Sheduleorder applied={applied} orderId={orderId} />
                                    )} */}

                                </div>
                            </div>
                        )}


                    </div >


                    {/* ===================================== GST POP UP DATA =============================================================== */}


                    {
                        showPopup && (
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: "rgba(0, 0, 0, 0.6)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 999,
                                    animation: "fadeIn 0.3s ease-in-out",
                                }}
                            >
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
                                        padding: "25px",
                                        borderRadius: "12px",
                                        width: "400px",
                                        boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                                        textAlign: "center",
                                        animation: "scaleUp 0.3s ease-in-out",
                                    }}
                                >
                                    <h3 style={{ marginBottom: "15px", color: "#333", fontSize: "20px" }}>
                                        GST Breakdown
                                    </h3>

                                    {gstData.length > 0 ? (
                                        gstData.map((gst, index) => (
                                            <ul
                                                key={index}
                                                style={{
                                                    listStyle: "none",
                                                    padding: "12px",
                                                    margin: "12px 0",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "8px",
                                                    background: "#fff",
                                                    textAlign: "left",
                                                }}
                                            >
                                                <li style={{ margin: "6px 0", fontSize: "16px", color: "#444" }}>
                                                    <strong>Service Charge GST:</strong> ₹{gst.serviceChargeGst}
                                                </li>
                                                <li style={{ margin: "6px 0", fontSize: "16px", color: "#444" }}>
                                                    <strong>Platform Charge GST:</strong> ₹{gst.platformChargeGst}
                                                </li>
                                                <li style={{ margin: "6px 0", fontSize: "16px", color: "#444" }}>
                                                    <strong>CGST:</strong> ₹{gst.cgst}
                                                </li>
                                                <li style={{ margin: "6px 0", fontSize: "16px", color: "#444" }}>
                                                    <strong>SGST:</strong> ₹{gst.sgst}
                                                </li>
                                            </ul>
                                        ))
                                    ) : (
                                        <p style={{ color: "#777" }}>No GST data available</p>
                                    )}

                                    <button
                                        onClick={() => setShowPopup(false)}
                                        style={{
                                            marginTop: "20px",
                                            padding: "10px 18px",
                                            background: "linear-gradient(90deg, #007bff, #0056d2)",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            border: "none",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            transition: "all 0.3s ease",
                                        }}
                                        onMouseOver={(e) =>
                                        (e.target.style.background =
                                            "linear-gradient(90deg, #0056d2, #003c99)")
                                        }
                                        onMouseOut={(e) =>
                                        (e.target.style.background =
                                            "linear-gradient(90deg, #007bff, #0056d2)")
                                        }
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        )
                    }



                    {/* Dine in First Modal.............. */}
                    <Modal
                        isOpen={isModalOpen}
                        onRequestClose={closeModal}
                        contentLabel="Add to Cart"
                        style={{
                            overlay: {
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                zIndex: 1000,
                            },
                            content: {
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '90%',
                                maxWidth: '600px',
                                scrollbarWidth: "none",

                                border: 'none',
                                boxShadow: '0px 4px 20px rgba(0,0,0,0.2)',
                                background: '#fff',
                                padding: '0px',
                                borderRadius: '10px',
                                height: 'auto',
                            },
                        }}
                    >
                        {/* Close Button */}
                        <button
                            onClick={closeModal}
                            style={{
                                position: 'absolute',
                                right: '0px',
                                top: '0px',
                                background: 'transparent',
                                border: 'none',
                                fontSize: '30px',
                                cursor: 'pointer',
                                color: '#fff',
                                zIndex: 1001,
                            }}
                            aria-label="Close"
                        >
                            &times;
                        </button>

                        {/* Modal Content */}
                        <div style={{ textAlign: 'center' }}>
                            {/* Header */}
                            <h3
                                style={{
                                    background: '#b15dc6',
                                    height: '65px',
                                    color: '#fff',
                                    padding: '10px',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    marginBottom: '20px',
                                    borderRadius: '8px 8px 0 0',
                                }}
                            >
                                ENTER YOUR ORDER DETAILS
                            </h3>

                            {/* Dine In Label */}
                            <h3 style={{ fontWeight: 900, fontSize: '18px', marginBottom: '15px' }}>Dine In</h3>

                            {/* Use Location Button */}
                            <button
                                style={{
                                    height: '40px',
                                    borderRadius: '10px',
                                    width: '80%',
                                    maxWidth: '250px',
                                    textAlign: 'center',
                                    backgroundColor: '#b15dc6',
                                    color: '#fff',
                                    border: 'none',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                }}
                                onClick={handleUseMyLocation}
                            >
                                Use My Location
                            </button>

                            <h4 style={{ margin: '15px 0' }}>OR</h4>

                            {/* Input Field */}
                            <input
                                type="text"
                                value={inputValue}
                                onChange={handleChange}
                                placeholder="Search by state or city or zip"
                                style={{
                                    width: '90%',
                                    maxWidth: '400px',
                                    padding: '10px',
                                    borderRadius: '5px',
                                    border: '1px solid #ccc',
                                    marginBottom: '10px',
                                }}
                            />

                            {/* Dropdown Suggestions */}
                            {showDropdown && (
                                <ul
                                    style={{
                                        listStyle: 'none',
                                        margin: 0,
                                        padding: 0,
                                        border: '1px solid #ccc',
                                        borderRadius: '5px',
                                        background: '#fff',
                                        position: 'absolute',
                                        width: '90%',
                                        maxWidth: '400px',
                                        alignItems: "center",
                                        maxHeight: '150px',
                                        overflowY: 'auto',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        zIndex: 1002,
                                    }}
                                >
                                    {filteredSuggestions.length > 0 ? (
                                        filteredSuggestions.map((item, index) => (
                                            <li
                                                key={index}
                                                onClick={() => {
                                                    handleSelect(item);
                                                    closeModal();
                                                }}
                                                style={{
                                                    padding: '10px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #eee',
                                                }}
                                            >
                                                {item}
                                            </li>
                                        ))
                                    ) : (
                                        <li style={{ padding: '10px', color: '#999' }}>No results found</li>
                                    )}
                                </ul>
                            )}
                        </div>
                    </Modal>
                </div >
            ) : (
                <>
                    {selectedDate && selectedTime ? (
                        <Sheduleorder />
                    ) : (
                        <Paymentdata />
                    )}
                </>
            )
            }
        </div >
    );
};

export default Ordercart;


